import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DefectManagementElement } from '../models/defectManagementElement';
import { OrderProcessingElement } from '../models/O3AdministrationModels/orderProcessingElement';
import { UserManager } from '../models/usermanagement/userManager';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class DataSourceService {
  // tslint:disable-next-line:typedef
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }

  
  constructor(private http: HttpClient) { }

  getOrderProcessingElementData(): Observable<OrderProcessingElement[]> {
    return this.http.get<OrderProcessingElement[]>('/assets/data/data-source.json');
  }

  getDefectManagementElementData(): Observable<DefectManagementElement[]> {
    return this.http.get<DefectManagementElement[]>('/assets/data/data-source-defect-management.json');
  }

  getUserData(data: any): Observable<UserManager[]> {
    return this.http.post<UserManager[]>(this.baseUrl + 'Account/GetUserManagerList', data);
  }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  getPlantData(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'Common/GetDepartments', data);
  }

  getProductFamilyData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProductFamilies', data);
  }

  updateProductFamily(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdateProductFamily', data);
  }

  GetProductFamiliesDropDown(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProductFamiliesDropDown', data);
  }

  InsertProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertProduct', data);
  }

  GetProducts(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProducts', data);
  }
  GetActiveSpecificationsHistory(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'PM/GetActiveSpecificationsHistory', data);
  }

  GetProductProperties(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProductProperties', data);
  }

  InsertProductProperty(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertProductProperty', data);
  }

  UpdateProductProperty(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdateProductProperty', data);
  }

  GetCharacteristics(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetCharacteristics', data);
  }

  InsertCharacteristics(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertCharacteristics', data);
  }

  UpdateCharacteristics(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdateCharacteristics', data);
  }

  GetSpecifications(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetSpecifications', data);
  }

  GetDataTypes(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetDataTypes', data);
  }

  GetActiveSpecifications(data: any): Observable<any[]> {

    return this.http.post<any[]>(this.baseUrl + 'PM/GetActiveSpecifications', data);
  }

  InsertSpecifications(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertSpecifications ', data);
  }

  GetTreeModal(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetTreeModal', data);
  }

  GetProductUnits(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProductUnits', data);
  }

  GetProductPropertiesForMappings(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProductPropertiesForMappings', data);
  }

  GetPropertyMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetPropertyMapping', data);
  }

  UpdateSpecifications(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdateSpecifications', data);
  }

  GetCharacteristicsByProductProperties(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetCharacteristicsByProductProperties', data);
  }

  GetSpecificationsByProductProperties(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetSpecificationsByProductProperties', data);
  }

  InsertMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertMapping', data);
  }

  UpdateMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdateMapping', data);
  }

  DeleteMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteMapping', data);
  }

  DeleteSpecifications(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteSpecifications', data);
  }

  InsertProductUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertProductUnit', data);
  }

  DeleteProductUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteProductUnit', data);
  }

  GetProductUnitsDropDown(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/GetProductUnitsDropDown', data);
  }

  InsertPropertyMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertPropertyMapping', data);
  }

  InsertProductFamily(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/InsertProductFamily', data);
  }

  UpdateProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdateProduct', data);
  }

  DeleteProductFamily(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteProductFamily', data);
  }

  DeleteProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteProduct', data);
  }

  DeleteProductPropertyeteProduct(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteProductProperty', data);
  }

  DeletePropertyMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeletePropertyMapping', data);
  }

  DeleteCharacteristics(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/DeleteCharacteristics', data);
  }

  UpdatePropertyMapping(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'PM/UpdatePropertyMapping', data);
  }

}
